import type { LegalDocumentId } from './legal-document-paths';
import { legalDocumentSchema, type LegalDocument } from './legal-document-schema';

/**
 * One dynamic import per document, so each lands in its own chunk and only its
 * own page downloads it. A static import here would put every document in
 * every signup page, since the routes import the feature through its barrel.
 */
const LOADERS: Record<LegalDocumentId, () => Promise<{ default: unknown }>> = {
  'terms-of-use': () => import('./documents/terms-of-use.json'),
  'privacy-policy': () => import('./documents/privacy-policy.json'),
  'notice-of-privacy-practices': () => import('./documents/notice-of-privacy-practices.json'),
  'consumer-health-data-privacy-notice': () =>
    import('./documents/consumer-health-data-privacy-notice.json'),
  'ai-notice': () => import('./documents/ai-notice.json'),
  'tcpa-authorization': () => import('./documents/tcpa-authorization.json'),
};

export async function loadLegalDocument(id: LegalDocumentId): Promise<LegalDocument> {
  const module = await LOADERS[id]();
  return legalDocumentSchema.parse(module.default);
}
